import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import _ from 'lodash';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { DndProvider } from 'react-dnd';
import { ToastContainer } from 'react-toastify';
import HTML5Backend from 'react-dnd-html5-backend';
import { loadProgressBar } from 'axios-progress-bar';
import IdleTimer from 'react-idle-timer';
import Vimeo from '@u-wave/react-vimeo';
import * as urls from '../actions/urlTypes';
import {
  APP_ROOT_URL,
  DEFAULT_LANDING_PAGE,
  LANDING_PREFERENCES,
} from '../actions/urlTypes';
import * as studyActions from '../actions/studyActions';
import * as preferenceActions from '../actions/preferencesActions';
import { acceptTerms, logOut } from '../actions/loginActions';
import Navigation from '../components/Navigation';
import WarningIcon from './WarningIcon';
import ErrorBoundary from '../components/ErrorBoundary';
import {
  isFeaturePresent,
  getStudyFromStudies,
  filterStudyList,
} from '../util/CommonUtils';
import {
  CROSSTAB_FEATUREID,
  QUICKREPORTS_FEATUREID,
  DATAHAUL_FEATUREID,
  STORIES_FEATUREID,
  MME_FEATUREID,
  GEOMAPPING_FEATUREID,
  CORRCLUSTER_FEATUREID,
  VIMEO_IDS,
} from '../constants';
import { getGeoMappingStudies } from '../actions/geoMappingActions';
import PortalModal from '../components/common/Modal/PortalModal';
import GenericButton from '../components/common/GenericButton';
import AcceptTermsModal from '../components/common/AcceptTermsModal';

const tpModules = ['/v2/support', '/change-password'];
class Main extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  constructor(props) {
    super(props);
    sessionStorage.setItem('isIdle', false);
    this.idleTimer = null;
    this.state = {
      timeout: 1000 * 60 * 115,
      totalTime: 1000 * 60 * 5,
      remaining: 0,
      isIdle: false,
      isStudy: true,
      hasAccount: true,
      updateflag: true,
      hasRoles: true,
      url: '',
      isModalOpen: false,
      termsAccepted: this.props.loginResponse.data.termsAccepted,
    };
  }

  UNSAFE_componentWillMount() {
    const {
      uid,
      currentAccountId,
      canImpersonate,
      impersonated,
      universityUser,
    } = this.props.loginResponse.data;
    const { modulePermissions, isTPAccount } = this.props;
    const routeUrl = window.location.pathname;
    const crossTabRoute = routeUrl === '/' || routeUrl === '/crosstab';
    const isChangePassword = routeUrl.includes('change-password');
    // const isTurnkeyOmnibus = routeUrl.includes('edge');
    const isOmnibus = routeUrl.includes('omnibus');
    const isBrandCatalyst = routeUrl.includes('/catalyst/brandcatalyst');
    const isStories = routeUrl.includes('/essentials/stories');
    const isAdmin = routeUrl.includes('/admin');
    const isSupport = routeUrl.includes('/v2/support');

    this.getteaserVideoLinks();
    const impersonateRoutes =
      isChangePassword ||
      isOmnibus ||
      isBrandCatalyst ||
      isStories ||
      isAdmin ||
      isSupport;
    const nonImpersonateRoute =
      !canImpersonate && impersonated && impersonateRoutes;

    const requiredRoutes = [];
    const defaultLandingPage = isTPAccount
      ? `/v2/support`
      : DEFAULT_LANDING_PAGE;

    const isPreferenceRouteAvailable =
      defaultLandingPage !== null &&
      defaultLandingPage !== undefined &&
      defaultLandingPage !== '';
    if (
      crossTabRoute ||
      nonImpersonateRoute ||
      (universityUser && isChangePassword)
    ) {
      if (modulePermissions.length > 0 && !isTPAccount) {
        _.map(LANDING_PREFERENCES, (item, i) => {
          if (modulePermissions.includes(item.id)) {
            let defaultFlag = false;
            if (isPreferenceRouteAvailable) {
              const defaultPage = defaultLandingPage.toLowerCase();
              defaultFlag = item.url === defaultPage;
            } else {
              if (i === 0) {
                defaultFlag = true;
              }
            }
            requiredRoutes.push({ ...item, defaultFlag });
          }
        });
        const currentroute = requiredRoutes.filter(item => item.defaultFlag);
        if (currentroute.length === 0) {
          requiredRoutes[0].defaultFlag = true;
          this.context.router.push(`${APP_ROOT_URL}${requiredRoutes[0].url}`);
        } else {
          this.context.router.push(`${APP_ROOT_URL}${currentroute[0].url}`);
        }
      } else if (defaultLandingPage === '/v2/support') {
        window.location.href = `${APP_ROOT_URL}${defaultLandingPage}`;
      } else {
        this.context.router.push(`${APP_ROOT_URL}${defaultLandingPage}`);
      }
    }
    this.setState(
      {
        hasAccount: currentAccountId && true,
        hasRoles: !_.isEmpty(modulePermissions),
      },
      () => {
        if (!isTPAccount) {
          if (currentAccountId && !_.isEmpty(modulePermissions)) {
            const apiCallsArr = [];
            if (
              this.checkPermission(CROSSTAB_FEATUREID) ||
              this.checkPermission(QUICKREPORTS_FEATUREID) ||
              this.checkPermission(DATAHAUL_FEATUREID) ||
              this.checkPermission(STORIES_FEATUREID) ||
              this.checkPermission(MME_FEATUREID) ||
              this.checkPermission(GEOMAPPING_FEATUREID) ||
              this.checkPermission(CORRCLUSTER_FEATUREID)
            ) {
              apiCallsArr.push(
                this.props.studyActions.getStudies(uid, currentAccountId)
              );
            }
            Promise.all(apiCallsArr).then(status => {
              if (!universityUser) {
                this.setState({ isStudy: status });
              }
            });
          }
        } else {
          this.getSiStudies();
        }
      }
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      !this.props.isTPAccount &&
      this.props.autoUpdateFlag &&
      nextProps.userPreferences &&
      nextProps.studies &&
      this.state.updateflag
    ) {
      this.setState({ updateflag: false });
      this.props.preferenceActions.setAutoUpdateFlag();
    }
    this.getteaserVideoLinks();
  }

  getteaserVideoLinks = () => {
    const routeUrl = window.location.pathname;
    this.setState({ url: null });

    const module = VIMEO_IDS.find(e => routeUrl.includes(e.key));
    module
      ? this.setState({ url: module.value })
      : this.setState({ url: null });
  };

  getSiStudies = () => {
    const {
      uid,
      currentAccountId,
      universityUser,
    } = this.props.loginResponse.data;

    const apiCallsArr = [];
    apiCallsArr.push(this.props.studyActions.getStudies(uid, currentAccountId));
    Promise.all(apiCallsArr).then(status => {
      if (!universityUser) {
        this.setState({ isStudy: status });
      }
    });
  };

  getStudyName = (prefStudyType, studies, featureID) => {
    const studyList = filterStudyList(studies, featureID);
    const StudyType = getStudyFromStudies(studyList, prefStudyType);
    if (StudyType && Object.keys(StudyType).length > 0) {
      return {
        study: StudyType.st,
        productNo: StudyType.pn,
        studyDescription: StudyType.sd,
      };
    }
    return {
      study: studyList[0].sl[0].st,
      productNo: studyList[0].sl[0].pn,
      studyDescription: studyList[0].sl[0].sd,
    };
  };

  checkPermission(moduleFeature) {
    const { modulePermissions } = this.props;
    let hasFeature = false;
    if (modulePermissions.length > 0) {
      hasFeature = isFeaturePresent(moduleFeature, modulePermissions);
    }
    return hasFeature;
  }

  startRemeaningTime = () => {
    const startTime = new Date().getTime();
    const { totalTime } = this.state;
    let timer = 0;
    this.interval = setInterval(() => {
      if (new Date().getTime() - startTime >= totalTime) {
        this._logout();
        timer = 0;
        clearInterval(this.interval);
        return;
      }
      timer += 1;
      const remeaningTime = totalTime - 1000 * timer;
      this.setState({ remaining: remeaningTime });
    }, 1000);
  };

  _onIdle = () => {
    this.setState({ isIdle: true }, () => {
      sessionStorage.setItem('isIdle', this.state.isIdle);
      this.startRemeaningTime();
    });
  };

  _reset = () => {
    this.setState({ isIdle: false }, () => {
      this.idleTimer.reset();
      clearInterval(this.interval);
    });
  };

  _logout = () => {
    this.setState({ isIdle: false }, () => {
      this.idleTimer.reset();
      clearInterval(this.interval);

      const state = this.props.currentState;
      const uid = this.props.loginResponse.data.uid;
      const accountId = this.props.activeAccountId;
      logOut(state, uid, accountId);
    });
  };

  millisToMinutesAndSeconds = millis => {
    const minutes = Math.floor(millis / 60000);
    const seconds = ((millis % 60000) / 1000).toFixed(0);
    return `${minutes} minutes ${seconds} seconds`;
  };

  renderLogoutModal = () => {
    return (
      <PortalModal
        title="Error!"
        isShowing={this.props.isLogout}
        hideCloseButton
        dialogStyles={{
          left: '30%',
          top: '10%',
          width: '570px',
          height: '674px,',
        }}
        onCloseClicked={() => console.log('test close')}
      >
        <div>
          Your settings have changed,. In order to continue, please logout and
          log back in.
        </div>
        <div className="logout">
          <GenericButton
            name="Logout"
            btnStyle="button display-block margin-auto"
            onBtnClick={() => logOut()}
          />
        </div>
      </PortalModal>
    );
  };

  renderTimeOutModal = () => {
    return (
      <div className="idle-timer-modal">
        <div className="idle-timer-modal-container">
          <div className="idle-timer-modal-header">
            <h3>Session Timeout</h3>
          </div>
          <div className="idle-timer-modal-body">
            <p>
              Your session will expire in{' '}
              {this.millisToMinutesAndSeconds(this.state.remaining)}”. Click{' '}
              <strong>“Continue”</strong> to keep working or click{' '}
              <strong>“Log Off”</strong> to end your session now.
            </p>
          </div>
          <div className="idle-timer-modal-footer">
            <button className="button btn-cncl" onClick={this._reset}>
              Continue
            </button>
            <button className="button btn-cncl" onClick={this._logout}>
              Log Off
            </button>
          </div>
        </div>
      </div>
    );
  };

  render() {
    // show accept terms modal if termsAccepted and impersonated are false 
    if (
      !this.state.termsAccepted &&
      !this.props.loginResponse.data.impersonated
    ) {
      return (
        <AcceptTermsModal
          isOpen={!this.state.termsAccepted}
          acceptedOnClick={() => {
            this.setState({ termsAccepted: true });
            acceptTerms();
          }}
        />
      );
    }

    const { children } = this.props;
    const currentRoute = this.props.location.pathname;
    const isTpNav = tpModules.includes(currentRoute);

    const { timeout, isIdle, isStudy, hasAccount, hasRoles, url } = this.state;
    let studyError = (
      <div className="no-study-message">
        <WarningIcon />
        <p>
          There are no studies currently assigned to this account. Please
          contact your MRI-Simmons account team for assistance.
        </p>
      </div>
    );
    if (!hasAccount) {
      studyError = (
        <div className="no-study-message">
          <WarningIcon />
          <p>
            There are no account assigned to you. Please contact your
            MRI-Simmons account team for assistance.
          </p>
        </div>
      );
    }
    if (!hasRoles) {
      studyError = (
        <div className="no-study-message">
          <WarningIcon />
          <p>
            There are no Roles assigned to you. Please contact your MRI-Simmons
            account team for assistance.
          </p>
        </div>
      );
    }
    let renderModules = '';
    if (isStudy && hasAccount) {
      if (this.props.isTPAccount) {
        renderModules = children;
        if (isTpNav) {
          renderModules = children;
        } else {
          if (url) {
            renderModules = (
              <div className="player-wrapper">
                <div>
                  <Vimeo video={url} className="react-player" />
                </div>
              </div>
            );
          } else {
            renderModules = (
              <div className="no-study-message">
                <WarningIcon />
                <p>
                  Please contact your MRI-Simmons account team for assistance.
                </p>

                <p>
                  Please check our{' '}
                  <Link
                    rel="noopener noreferrer"
                    target="_blank"
                    href={`${urls.APP_ROOT_URL}/v2/support`}
                  >
                    Support
                  </Link>{' '}
                  section for further assistance.
                </p>
              </div>
            );
          }
        }
      } else if (!this.props.isTPAccount && hasRoles) {
        renderModules = children;
      } else {
        renderModules = studyError;
      }
    }

    return (
      <DndProvider backend={HTML5Backend}>
        <ErrorBoundary>
          <div className="main-app-container">
            {loadProgressBar()}
            <IdleTimer
              ref={ref => {
                this.idleTimer = ref;
              }}
              onIdle={this._onIdle}
              timeout={timeout}
              startOnLoad
            />
            {isIdle && this.renderTimeOutModal()}
            <link
              rel="stylesheet"
              href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css"
            />
            <div>
              <div>
                <Navigation isStudy={isStudy} hasAccount={hasAccount} />
                {renderModules}
              </div>
              {this.props.isLogout && this.renderLogoutModal()}
              <ToastContainer />
            </div>
          </div>
        </ErrorBoundary>
      </DndProvider>
    );
  }
}

Main.propTypes = {
  children: PropTypes.node,
  studyActions: PropTypes.shape({
    getStudies: PropTypes.func,
    getLatestStudy: PropTypes.func,
  }),
  preferenceActions: PropTypes.shape({
    getUserPrefrences: PropTypes.func,
    setAutoUpdateFlag: PropTypes.func,
  }),
  getUserPrefrences: PropTypes.func,
  autoUpdateFlag: PropTypes.bool,
  studies: PropTypes.arrayOf(PropTypes.object),
  activeAccountId: PropTypes.number,
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      currentAccountId: PropTypes.number,
      impersonated: PropTypes.bool,
      canImpersonate: PropTypes.bool,
      universityUser: PropTypes.bool,
      termsAccepted: PropTypes.bool,
    }),
  }),
  modulePermissions: PropTypes.instanceOf(Array),
  getGeoMappingStudies: PropTypes.func,
  isTPAccount: PropTypes.bool,
  isLogout: PropTypes.bool,
};

const mapStateToProps = state => {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    currentState: state,
    studies: state.study.studies,
    autoUpdateFlag: state.preferences.autoUpdateFlag,
    userPreferences: state.preferences.userPreferences,
    modulePermissions: state.userDetail.permissions,
    isTPAccount: state.account.isTPAccount,
    isLogout: state.login.isLogout,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    studyActions: bindActionCreators(studyActions, dispatch),
    preferenceActions: bindActionCreators(preferenceActions, dispatch),
    getGeoMappingStudies: bindActionCreators(getGeoMappingStudies, dispatch),
  };
};

// const MainApp = dragDropContext(HTML5Backend)(Main);
export default connect(mapStateToProps, mapDispatchToProps)(Main);
